module.exports = {
  request: {
    maxRetryError: 5,
    timeout: 50000,
  },
  api: {
    mts: 'https://g6live.cnnd.vn/mts-api/',
  },
};
